module.exports = __webpack_public_path__ + "img/saldo-yesdok-new.1536048.svg";